import { AxiosResponse } from 'axios';

export default class DataGridService {
    public async LoadFromServer(endPoint: string, pageSize: number, pageNumber: number, searchTerms: any) {
        const postData = {
            PageSize: pageSize,
            PageNumber: pageNumber,
            SearchTerms: searchTerms
        };

        try {
            const axios = require('axios').default;
            const response: AxiosResponse = await axios.post(endPoint, postData);

            return { Error: false, Data: response.data };
        } catch (error) {
            return { Error: true, Message: error };
        }
    }
}
